import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

import {
  getCalendarFeedUrlStart,
  getCalendarFeedUrlSuccess,
  getCalendarFeedUrlFailure,
} from "../slices/calendarFeedSlice";

// Get calendar feed URL
export const getCalendarFeedUrl = createAsyncThunk(
  "calendarFeed/getCalendarFeedUrl",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const state = getState();
    const token = state.auth.token;
    const userId = state.auth.user._id;
    const { baseURL, config } = generateConfig({ token });

    try {
      const response = await axios.get(
        `${baseURL}/api/user/${userId}/calendar-feed-url`,
        config
      );
      return response.data;
    } catch (error) {
      // Extract error message from response
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to get calendar feed URL";
      return rejectWithValue(errorMessage);
    }
  }
);

// Regenerate calendar feed URL (in case of compromise)
export const regenerateCalendarFeedUrl = createAsyncThunk(
  "calendarFeed/regenerateCalendarFeedUrl",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const state = getState();
    const token = state.auth.token;
    const userId = state.auth.user._id;
    const { baseURL, config } = generateConfig({ token });

    try {
      const response = await axios.post(
        `${baseURL}/api/user/${userId}/calendar-feed-url/regenerate`,
        {},
        config
      );
      return response.data;
    } catch (error) {
      // Extract error message from response
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to regenerate calendar feed URL";
      return rejectWithValue(errorMessage);
    }
  }
);
